import { NavigationItem } from "./layouts/navigation-template/navigation-template";

export const navigation: NavigationItem[] = [
    {
        text: 'LAVORI',
        path: '/lavori',
        icon: 'edit',
        feature: 'Timesheet.OreCommessa'
    },
    {
        text: 'RAPPORTINI',
        path: '/rapportini',
        icon: 'docs',
        feature: 'ATS.GestioneRapportini'
    },
    {
        text: 'CALENDARIO LAVORI',
        path: 'calendario-lavori',
        icon: 'calendar_month',
        feature: 'Timesheet.OreCommessa'
    },
    {
        text: 'RIEPILOGO GIUSTIFICATIVI',
        path: 'riepilogo-giustificativi',
        icon: 'receipt',
        feature: 'Timesheet.OreCommessa'
    },
    {
        text: 'SITUAZIONE COMMESSE',
        path: 'situazione-commesse',
        icon: 'trending_up',
        feature: 'Timesheet.SituazioneCommesse'
    },
    {
        text: 'RICHIESTE',
        path: '',
        icon: 'add_task',
        feature: '',
        items: [
            {
                text: 'FERIE/PERMESSI',
                path: 'richiesta-ferie',
                icon: 'plane_contrails',
                feature: 'Timesheet.RichiesteCdL'
            }
        ]
    },
    {
        text: 'APPROVAZIONI',
        path: '',
        icon: 'rule',
        feature: '',
        items: [
            {
                text: 'FERIE/PERMESSI',
                path: 'approvazione-ferie',
                icon: 'plane_contrails',
                feature: 'Timesheet.ApprovazioniCdL'
            }
        ]
    },
    {
        text: "PIANO FERIE",
        path: '/piano-ferie',
        icon: 'event_busy',
        feature: 'Timesheet.PianoFerie'
    },
    {
        text: 'UTILITÀ',
        path: '',
        icon: 'service_toolbox',
        feature: '',
        items: [
            {
                text: 'CARICA GIUSTIFICATIVI',
                path: '/carica-giustificativi',
                icon: 'upload_file',
                feature: 'Timesheet.OreCommessa'
            }
        ]
    }
];